import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'
const api = async (method, path, params) => axios[method](path, params)

const state = {
    item: null,
    template_item: null,
    template_items: [],
    items: [],
    transfer_items: [],
    section_items: [],
    pagination: null,
    sectionPagination: null,
    historyItems: [],
    sectionLoadingState: false,
    unit_of_measures : [],
    attachments: [],
    filters: {},
    query: '',
    item_groups:[],
}

const getters = {
    sections(state) {
        const item = state.item || {}
        return item.sections || []
    },
    discountMasterItems(state, getters, rootState) {
        const discountTypes = rootState.itemType.items.filter(
            x => x.is_discount && x.is_order_item
        )
        return state.items.filter(x => {
            const isDiscountType = discountTypes.some(
                y => y.id == x.order_item_type_id
            )
            return isDiscountType
        })
    },
}

const mutations = {
    SET_ITEM(state, payload) {
        state.item = payload
    },
    SET_TEMPLATE_ITEM(state, payload) {
        state.template_item = payload
    },
    SET_HISTORYITEMS(state, payload) {
        state.historyItems = payload
    },
    SET_ITEMS(state, payload) {
        state.items = payload
    },
    SET_FILTERS(state, payload) {
        state.filters = payload
    },
    SET_QUERY(state, payload) {
        state.query = payload
    },
    SET_TEMPLATE_ITEMS(state, payload) {
        state.template_items = payload
    },
    SET_PAGINATION(state, pag) {
        state.pagination = pag
    },
    SET_SECTIONPAGINATION(state, sectionpage) {
        state.sectionPagination = sectionpage
    },

    SET_SECTION_ITEMS(state, payload) {
        state.section_items = payload
    },
    SET_TRANSFER_ITEMS(state, payload) {
        state.transfer_items = payload
    },
    SET_ITEM_MASTER(state, payload) {
        state.section_master = payload
    },

    SET_UOM(state, payload) {
        state.unit_of_measures = payload
    },
    SET_ATTACHMENTS(state, attachments) {
        state.attachments = attachments;
      },
      clearAssetsAttachments(state) {
        state.attachments = [];
    },
    SET_ITEM_GROUPS(state,payload){
        state.item_groups = payload
    }
}

const actions = {
    async fetchById(context, id) {
        try {
            const results = await api('get', `master-item/${id}`)
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchByIdFunction(context, id) {
        try {
            const results = await api('get', `master-item/${id}`)
            context.commit('SET_ITEM', results.data.success.data)
            return results.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchByIds(context, params) {
        try {
            const results = await api('post', `master-item/fetch-by-ids`, params)
            return results.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchallMaster(context) {
        try {
            const results = await api('get', `master-item/inventory`)
            context.commit('SET_ITEM_MASTER', results)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetch(context, params) {
        console.log('masterItem/fetch', params)
        // Destructure Params
        let { query, page: pg, filters } = params || {}

        // Initialize query params and filters if nothing is passed in
        query = query || ''
        pg = pg || 1
        filters = filters || {}
        try {
            console.log('ORG filters:::', filters)
            const path = `master-item?q=${query}&page=${pg}&${buildQuery(
                filters
            )}`

            const results = await api('get', path)

            // Destructure search data
            let {
                data,
                current_page: page,
                per_page: pageSize,
                total,
            } = results.data.success.data

            context.commit('SET_FILTERS', filters)

            context.commit('SET_QUERY', query)

            context.commit('SET_ITEMS', data)
            // set pagination object
            context.commit('SET_PAGINATION', {
                page,
                pageSize,
                total,
            })
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAll(context, params) {
        console.log('masterItem/fetch', params)
        // Destructure Params
        let { query, filters } = params || {}

        // Initialize query params and filters if nothing is passed in
        query = query || ''
        filters = filters || {}
        try {
            console.log('ORG filters:::', filters)
            const path = `master-item?q=${query}&${buildQuery(filters)}`

            const results = await api('get', path)

            // Destructure search data
            let { data } = results.data.success.data

            context.commit('SET_ITEMS', data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchHistory(context,
        { query, filters }
        ) {
        try {
            const path = `master-item/all/history?q=${query}&${buildQuery(filters)}`
            const results = await api('get', path)
            let data = results.data.success.data
            context.commit('SET_HISTORYITEMS', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchSelectedItems({ commit }, list) {
        try {
            const queryStr = list.reduce((_qr, x) => {
                if (_qr) {
                    _qr = _qr + `&ids[]=${x}`
                } else {
                    _qr = `ids[]=${x}`
                }
                return _qr
            }, '')
            const path = `master-item/inventory?${queryStr}&page=1`

            const results = await api('get', path)
            // console.log('fetch historyresults', results)

            // Destructure search data
            let data = results.data.success.data
            
            const {
                data: items = [],
                current_page: page = 1,
                per_page: pageSize = 15,
                total = 0,
            } = data || {};
            
            commit('SET_SECTION_ITEMS', items)
            commit("SET_SECTIONPAGINATION", {
                page,
                pageSize,
                total,
              });
            //////////context.commit('SET_HISTORYITEMS', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchSection({ commit }, params) {
        // Destructure Params
        let { query, filters, page: page_no } = params || {}

        // Initialize query params and filters if nothing is passed in
        query = query || ''
        filters = filters || {}
        try {
            console.log('filters:::', filters)
            const path = `master-item/inventory?q=${query}&page=${page_no}&${buildQuery(
                filters
            )}`
            const results = await api('get', path)
            // Destructure search data
            let data = results.data.success.data
            
            const {
                data: items = [],
                current_page: page = 1,
                per_page: pageSize = 15,
                total = 0,
            } = data || {};
            
            commit('SET_SECTION_ITEMS', items)
            commit("SET_SECTIONPAGINATION", {
                page,
                pageSize,
                total,
              });

        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchBySection(context, section_id) {
        console.log('fetchBySection-section_id', section_id)
        try {
            const results = await api(
                'get',
                `master-item/section/${section_id}`
            )
            const sectionItems = results.data.success.data
            context.commit('SET_SECTION_ITEMS', sectionItems)
        } catch (err) {
            errorHandler(err)
        }
    },

    async create(context, payload) {
        try {
            const results = await api('post', `master-item`, payload)
            context.commit('SET_ITEM', results.data.success.data)
            return results.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async transfer(context, payload) {
        try {
            const results = await api(
                'post',
                `master-item/bulk-inventory-transfer`,
                payload
            )
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `master-item/${payload.id}`,
                payload
            )
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `master-item/${id}`)
            context.commit('SET_ITEM', null)
            context.dispatch('fetch')
        } catch (err) {
            errorHandler(err)
        }
    },

    //sections
    async addSection(context, { master_item_id, model }) {
        try {
            const path = `master-item/${master_item_id}/sections`
            const results = await api('post', path, model)
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async unit_of_measures(context) {
        try {
            const path = `master-item/unit-of-measures`
            const results = await api('get', path)
            let data = results.data.success.data
            context.commit('SET_UOM', data)
        } catch (err) {
            errorHandler(err)
        }
    },
    merge({ state, commit }, item) {
        // item.data.hash = item.data.hash || getHash()
        const items = [...state.template_items]
        let index = items.findIndex(x => x.id == item.id)
        if (index >= 0) items.splice(index, 1, item)
        else items.push(item)
        console.log(':getttttt', items)
        commit('SET_TEMPLATE_ITEMS', items)
        // commit('SET_ITEMS', items)
    },
    deleteTemplateItem({ state, commit }, item) {
        const items = [...state.template_items]
        const index = items.findIndex(x => x.id == item.id)
        items.splice(index, 1)
        // commit('SET_CHANGED', true)
        commit('SET_TEMPLATE_ITEMS', items)
    },
    async fetchGroup(context){
        try {
            const path = `master-item/item-group`
            const results = await api('get', path)
            let data = results.data.success.data
            context.commit('SET_ITEM_GROUPS', data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAttachments(context, master_item_id) {
        console.log('attachment is called');
        try {
          if(context.rootState.masterItemAttachmentsStore.attachments.length > 0){
            return;
          }
          if (
            state.attachments.length > 0 &&
            state.attachments[0].master_item_id == master_item_id
          ) {
            return;
          }
          const result = await axios.get(`master-item/${master_item_id}/attachments`)
    
          context.commit("SET_ATTACHMENTS", result.data.success.data);
        } catch (err) {
          errorHandler(err);
        }
      },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
